import {useDispatch} from 'react-redux';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Snackbar from '@mui/material/Snackbar';

import useError from '../../hooks/useError';
import {close as closeError} from '../../redux/reducers/errors';

const unknownErrorMessage = 'Zoinks! An unknown error has occurred, but rest assured we are here for you. Please contact us at info@movement-x.com for immediate support.  In the meantime, try restarting your browser or clearing your cookies.';

const ErrorFlash = props => {
  const {error, isClosed} = useError();
  const dispatch = useDispatch();
  const displayError = props.error || error;
  return (
    displayError && displayError.message && !['null', 'undefined'].includes(displayError.message)
    ? <Snackbar
      anchorOrigin={{vertical: 'top', horizontal: 'center'}}
      open={!isClosed}
    >
      <Alert 
        severity="error" 
        variant='outlined' 
        onClose={() => dispatch(closeError())}
        sx={{bgcolor: 'white'}}
      >
        <AlertTitle>Error</AlertTitle>
        {displayError.message || unknownErrorMessage}
      </Alert>
    </Snackbar>
    : <></>
  );
};

export default ErrorFlash;
